import { Controller } from "@hotwired/stimulus"

// Disables the form's submit button and swaps its icon to a spinner while a Turbo
// form submission is in flight, preventing a second click. Reset on submit-end for
// flows where the button survives the response (e.g. opening the trip picker).
export default class extends Controller {
  static targets = ["button", "icon"]

  start() {
    if (this.hasButtonTarget) this.buttonTarget.setAttribute("disabled", "disabled")
    if (this.hasIconTarget) {
      this.previousIconClass = this.iconTarget.className
      this.iconTarget.className = "fa-solid fa-spinner animate-spin text-base leading-none"
    }
  }

  end() {
    if (this.hasButtonTarget) this.buttonTarget.removeAttribute("disabled")
    if (this.hasIconTarget && this.previousIconClass) {
      this.iconTarget.className = this.previousIconClass
    }
  }
}
